import React from 'react'

const AdminYoutubePlayer = ({ src, id }) => {
    return (
        <div>
            <iframe id={id || "embed_videos"} className='w-100 rounded-4' width="560" height="315" src={src} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
    )
}

export default AdminYoutubePlayer